import React from "react";
import { RouteObject } from "react-router-dom";

import {
  checkAnyScope,
  checkBooleanScope,
} from "../../../components/ScopeWrappers/helpers";
import { AI_ROUTES } from "../../routes";

export const AiRoutes: RouteObject[] = [
  {
    path: AI_ROUTES.ScreenshotRecommendations,
    lazy: async () => {
      const { ScreenshotRecommendationsRoute } = await import(
        "../../../features/ai/pages/screenshotRecommendations/ScreenshotRecommendations.route"
      );
      const { ScopedRoute } = await import(
        "../../../components/ScopeWrappers/ScopedRoute"
      );
      return {
        element: (
          <ScopedRoute
            debugId={AI_ROUTES.ScreenshotRecommendations}
            isEnabled={(org) =>
              checkAnyScope([
                checkBooleanScope("enable_ai", org.configurations),
              ])
            }
            children={ScreenshotRecommendationsRoute}
          />
        ),
      };
    },
  },
];
